const Alice_Cooper = [
    {
        "name": "Lock Me Up",
        "youtube": "https://www.youtube.com/results?search_query=Lock%20Me%20Up%20Crystal%20Lake"
    },
    {
        "name": "Welcome to the Show",
        "youtube": "https://www.youtube.com/results?search_query=Welcome%20to%20the%20Show%20Crystal%20Lake"
    },
    {
        "name": "No More Mr. Nice Guy",
        "youtube": "https://www.youtube.com/results?search_query=No%20More%20Mr.%20Nice%20Guy%20Crystal%20Lake"
    },
    {
        "name": "I'm Eighteen",
        "youtube": "https://www.youtube.com/results?search_query=I'm%20Eighteen%20Crystal%20Lake"
    },
    {
        "name": "Under My Wheels",
        "youtube": "https://www.youtube.com/results?search_query=Under%20My%20Wheels%20Crystal%20Lake"
    },
    {
        "name": "Billion Dollar Babies",
        "youtube": "https://www.youtube.com/results?search_query=Billion%20Dollar%20Babies%20Crystal%20Lake"
    },
    {
        "name": "He's Back (The Man Behind the Mask)",
        "youtube": "https://www.youtube.com/results?search_query=He's%20Back%20(The%20Man%20Behind%20the%20Mask)%20Crystal%20Lake"
    },
    {
        "name": "Lost in America",
        "youtube": "https://www.youtube.com/results?search_query=Lost%20in%20America%20Crystal%20Lake"
    },
    {
        "name": "Hey Stoopid",
        "youtube": "https://www.youtube.com/results?search_query=Hey%20Stoopid%20Crystal%20Lake"
    },
    {
        "name": "Poison",
        "youtube": "https://www.youtube.com/results?search_query=Poison%20Crystal%20Lake"
    },
    {
        "name": "Feed My Frankenstein",
        "youtube": "https://www.youtube.com/results?search_query=Feed%20My%20Frankenstein%20Crystal%20Lake"
    },
    {
        "name": "Ballad of Dwight Fry",
        "youtube": "https://www.youtube.com/results?search_query=Ballad%20of%20Dwight%20Fry%20Crystal%20Lake"
    },
    {
        "name": "I Love the Dead",
        "youtube": "https://www.youtube.com/results?search_query=I%20Love%20the%20Dead%20Crystal%20Lake"
    },
    {
        "name": "Elected",
        "youtube": "https://www.youtube.com/results?search_query=Elected%20Crystal%20Lake"
    },
    {
        "name": "School's Out",
        "youtube": "https://www.youtube.com/results?search_query=School's%20Out%20Crystal%20Lake"
    }
]

const Crystal_Lake = [
    {
        "name": "Prometheus",
        "youtube": "https://www.youtube.com/results?search_query=Prometheus%20Crystal%20Lake"
    },
    {
        "name": "SIX FEET UNDER",
        "youtube": "https://www.youtube.com/results?search_query=SIX%20FEET%20UNDER%20Crystal%20Lake"
    },
    {
        "name": "Machina",
        "youtube": "https://www.youtube.com/results?search_query=Machina%20Crystal%20Lake"
    },
    {
        "name": "Mephisto",
        "youtube": "https://www.youtube.com/results?search_query=Mephisto%20Crystal%20Lake"
    },
    {
        "name": "Aeon",
        "youtube": "https://www.youtube.com/results?search_query=Aeon%20Crystal%20Lake"
    },
    {
        "name": "Denial",
        "youtube": "https://www.youtube.com/results?search_query=Denial%20Crystal%20Lake"
    },
    {
        "name": "Rebirth",
        "youtube": "https://www.youtube.com/results?search_query=Rebirth%20Crystal%20Lake"
    },
    {
        "name": "Blüdgod",
        "youtube": "https://www.youtube.com/results?search_query=Bl%C3%BCdgod%20Crystal%20Lake"
    },
    {
        "name": "Lost In Forever",
        "youtube": "https://www.youtube.com/results?search_query=Lost%20In%20Forever%20Crystal%20Lake"
    },
    {
        "name": "OPEN WATER",
        "youtube": "https://www.youtube.com/results?search_query=OPEN%20WATER%20Crystal%20Lake"
    },
    {
        "name": "Watch Me Burn",
        "youtube": "https://www.youtube.com/results?search_query=Watch%20Me%20Burn%20Crystal%20Lake"
    },
    {
        "name": "Apollo",
        "youtube": "https://www.youtube.com/results?search_query=Apollo%20Crystal%20Lake"
    }
]

const Machine_Head = [
    {
        "name": "Imperium",
        "youtube": "https://www.youtube.com/results?search_query=Imperium%20Crystal%20Lake"
    },
    {
        "name": "Ten Ton Hammer",
        "youtube": "https://www.youtube.com/results?search_query=Ten%20Ton%20Hammer%20Crystal%20Lake"
    },
    {
        "name": "CHØKE ØN THE ASHES ØF YØUR HATE",
        "youtube": "https://www.youtube.com/results?search_query=CH%C3%98KE%20%C3%98N%20THE%20ASHES%20%C3%98F%20Y%C3%98UR%20HATE%20Crystal%20Lake"
    },
    {
        "name": "Now We Die",
        "youtube": "https://www.youtube.com/results?search_query=Now%20We%20Die%20Crystal%20Lake"
    },
    {
        "name": "Is There Anybody Out There?",
        "youtube": "https://www.youtube.com/results?search_query=Is%20There%20Anybody%20Out%20There%3F%20Crystal%20Lake"
    },
    {
        "name": "Locust",
        "youtube": "https://www.youtube.com/results?search_query=Locust%20Crystal%20Lake"
    },
    {
        "name": "The Blood, the Sweat, the Tears",
        "youtube": "https://www.youtube.com/results?search_query=The%20Blood%2C%20the%20Sweat%2C%20the%20Tears%20Crystal%20Lake"
    },
    {
        "name": "NØ GØDS, NØ MASTERS",
        "youtube": "https://www.youtube.com/results?search_query=N%C3%98%20G%C3%98DS%2C%20N%C3%98%20MASTERS%20Crystal%20Lake"
    },
    {
        "name": "Darkness Within",
        "youtube": "https://www.youtube.com/results?search_query=Darkness%20Within%20Crystal%20Lake"
    },
    {
        "name": "Bulldozer",
        "youtube": "https://www.youtube.com/results?search_query=Bulldozer%20Crystal%20Lake"
    },
    {
        "name": "From This Day",
        "youtube": "https://www.youtube.com/results?search_query=From%20This%20Day%20Crystal%20Lake"
    },
    {
        "name": "Davidian",
        "youtube": "https://www.youtube.com/results?search_query=Davidian%20Crystal%20Lake"
    },
    {
        "name": "Halo",
        "youtube": "https://www.youtube.com/results?search_query=Halo%20Crystal%20Lake"
    }
]

const Sum_41 = [
    {
        "name": "Motivation",
        "youtube": "https://www.youtube.com/results?search_query=Motivation%20Crystal%20Lake"
    },
    {
        "name": "The Hell Song",
        "youtube": "https://www.youtube.com/results?search_query=The%20Hell%20Song%20Crystal%20Lake"
    },
    {
        "name": "Over My Head (Better Off Dead)",
        "youtube": "https://www.youtube.com/results?search_query=Over%20My%20Head%20(Better%20Off%20Dead)%20Crystal%20Lake"
    },
    {
        "name": "No Reason",
        "youtube": "https://www.youtube.com/results?search_query=No%20Reason%20Crystal%20Lake"
    },
    {
        "name": "Underclass Hero",
        "youtube": "https://www.youtube.com/results?search_query=Underclass%20Hero%20Crystal%20Lake"
    },
    {
        "name": "Landmines",
        "youtube": "https://www.youtube.com/results?search_query=Landmines%20Crystal%20Lake"
    },
    {
        "name": "We're All to Blame",
        "youtube": "https://www.youtube.com/results?search_query=We're%20All%20to%20Blame%20Crystal%20Lake"
    },
    {
        "name": "Walking Disaster",
        "youtube": "https://www.youtube.com/results?search_query=Walking%20Disaster%20Crystal%20Lake"
    },
    {
        "name": "Makes No Difference",
        "youtube": "https://www.youtube.com/results?search_query=Makes%20No%20Difference%20Crystal%20Lake"
    },
    {
        "name": "Drum Solo",
        "youtube": "https://www.youtube.com/results?search_query=Drum%20Solo%20Crystal%20Lake"
    },
    {
        "name": "Rise Up",
        "youtube": "https://www.youtube.com/results?search_query=Rise%20Up%20Crystal%20Lake"
    },
    {
        "name": "Pieces",
        "youtube": "https://www.youtube.com/results?search_query=Pieces%20Crystal%20Lake"
    },
    {
        "name": "We Will Rock You",
        "youtube": "https://www.youtube.com/results?search_query=We%20Will%20Rock%20You%20Crystal%20Lake"
    },
    {
        "name": "In Too Deep",
        "youtube": "https://www.youtube.com/results?search_query=In%20Too%20Deep%20Crystal%20Lake"
    },
    {
        "name": "Fat Lip",
        "youtube": "https://www.youtube.com/results?search_query=Fat%20Lip%20Crystal%20Lake"
    },
    {
        "name": "Still Waiting",
        "youtube": "https://www.youtube.com/results?search_query=Still%20Waiting%20Crystal%20Lake"
    },
    {
        "name": "Summer",
        "youtube": "https://www.youtube.com/results?search_query=Summer%20Crystal%20Lake"
    }
]


const Bruce_Dickinson = [
    {
        "name": "Accident of Birth",
        "youtube": "https://www.youtube.com/results?search_query=Accident%20of%20Birth%20Crystal%20Lake"
    },
    {
        "name": "Abduction",
        "youtube": "https://www.youtube.com/results?search_query=Abduction%20Crystal%20Lake"
    },
    {
        "name": "Laughing in the Hiding Bush",
        "youtube": "https://www.youtube.com/results?search_query=Laughing%20in%20the%20Hiding%20Bush%20Crystal%20Lake"
    },
    {
        "name": "Afterglow of Ragnarok",
        "youtube": "https://www.youtube.com/results?search_query=Afterglow%20of%20Ragnarok%20Crystal%20Lake"
    },
    {
        "name": "Chemical Wedding",
        "youtube": "https://www.youtube.com/results?search_query=Chemical%20Wedding%20Crystal%20Lake"
    },
    {
        "name": "Faith",
        "youtube": "https://www.youtube.com/results?search_query=Faith%20Crystal%20Lake"
    },
    {
        "name": "Tears of the Dragon",
        "youtube": "https://www.youtube.com/results?search_query=Tears%20of%20the%20Dragon%20Crystal%20Lake"
    },
    {
        "name": "Resurrection Men",
        "youtube": "https://www.youtube.com/results?search_query=Resurrection%20Men%20Crystal%20Lake"
    },
    {
        "name": "Rain on the Graves",
        "youtube": "https://www.youtube.com/results?search_query=Rain%20on%20the%20Graves%20Crystal%20Lake"
    },
    {
        "name": "Frankenstein",
        "youtube": "https://www.youtube.com/results?search_query=Frankenstein%20Crystal%20Lake"
    },
    {
        "name": "The Alchemist",
        "youtube": "https://www.youtube.com/results?search_query=The%20Alchemist%20Crystal%20Lake"
    },
    {
        "name": "Road to Hell",
        "youtube": "https://www.youtube.com/results?search_query=Road%20to%20Hell%20Crystal%20Lake"
    }
]

const Bring_Me_The_Horizon = [
    {
        "name": "DArkSide",
        "youtube": "https://www.youtube.com/results?search_query=DArkSide%20Crystal%20Lake"
    },
    {
        "name": "Empire (Let Them Sing)",
        "youtube": "https://www.youtube.com/results?search_query=Empire%20(Let%20Them%20Sing)%20Crystal%20Lake"
    },
    {
        "name": "MANTRA",
        "youtube": "https://www.youtube.com/results?search_query=MANTRA%20Crystal%20Lake"
    },
    {
        "name": "Teardrops",
        "youtube": "https://www.youtube.com/results?search_query=Teardrops%20Crystal%20Lake"
    },
    {
        "name": "AmEN!",
        "youtube": "https://www.youtube.com/results?search_query=AmEN!%20Crystal%20Lake"
    },
    {
        "name": "Kool-Aid",
        "youtube": "https://www.youtube.com/results?search_query=Kool-Aid%20Crystal%20Lake"
    },
    {
        "name": "Shadow Moses",
        "youtube": "https://www.youtube.com/results?search_query=Shadow%20Moses%20Crystal%20Lake"
    },
    {
        "name": "Obey",
        "youtube": "https://www.youtube.com/results?search_query=Obey%20Crystal%20Lake"
    },
    {
        "name": "Top 10 staTues tHat CriEd bloOd",
        "youtube": "https://www.youtube.com/results?search_query=Top%2010%20staTues%20tHat%20CriEd%20bloOd%20Crystal%20Lake"
    },
    {
        "name": "Kingslayer",
        "youtube": "https://www.youtube.com/results?search_query=Kingslayer%20Crystal%20Lake"
    },
    {
        "name": "Parasite Eve",
        "youtube": "https://www.youtube.com/results?search_query=Parasite%20Eve%20Crystal%20Lake"
    },
    {
        "name": "Antivist",
        "youtube": "https://www.youtube.com/results?search_query=Antivist%20Crystal%20Lake"
    },
    {
        "name": "Drown",
        "youtube": "https://www.youtube.com/results?search_query=Drown%20Crystal%20Lake"
    },
    {
        "name": "Can You Feel My Heart",
        "youtube": "https://www.youtube.com/results?search_query=Can%20You%20Feel%20My%20Heart%20Crystal%20Lake"
    },
    {
        "name": "Doomed",
        "youtube": "https://www.youtube.com/results?search_query=Doomed%20Crystal%20Lake"
    },
    {
        "name": "LosT",
        "youtube": "https://www.youtube.com/results?search_query=LosT%20Crystal%20Lake"
    },
    {
        "name": "Throne",
        "youtube": "https://www.youtube.com/results?search_query=Throne%20Crystal%20Lake"
    }
]

const Gorka = [
    {
        "name": "Maitasun bat",
        "youtube": "https://www.youtube.com/results?search_query=Maitasun%20bat%20Crystal%20Lake"
    },
    {
        "name": "Tren bat",
        "youtube": "https://www.youtube.com/results?search_query=Tren%20bat%20Crystal%20Lake"
    },
    {
        "name": "Lilura bat",
        "youtube": "https://www.youtube.com/results?search_query=Lilura%20bat%20Crystal%20Lake"
    },
    {
        "name": "Etorkizuna Ginenean",
        "youtube": "https://www.youtube.com/results?search_query=Etorkizuna%20Ginenean%20Crystal%20Lake"
    },
    {
        "name": "Kolore bat",
        "youtube": "https://www.youtube.com/results?search_query=Kolore%20bat%20Crystal%20Lake"
    },
    {
        "name": "Helduleku Guztiak",
        "youtube": "https://www.youtube.com/results?search_query=Helduleku%20Guztiak%20Crystal%20Lake"
    },
    {
        "name": "Janela bat",
        "youtube": "https://www.youtube.com/results?search_query=Janela%20bat%20Crystal%20Lake"
    },
    {
        "name": "Mihise zuri bat",
        "youtube": "https://www.youtube.com/results?search_query=Mihise%20zuri%20bat%20Crystal%20Lake"
    },
    {
        "name": "Maravillas",
        "youtube": "https://www.youtube.com/results?search_query=Maravillas%20Crystal%20Lake"
    },
    {
        "name": "Katamalo",
        "youtube": "https://www.youtube.com/results?search_query=Katamalo%20Crystal%20Lake"
    },
    {
        "name": "Sute bat",
        "youtube": "https://www.youtube.com/results?search_query=Sute%20bat%20Crystal%20Lake"
    },
    {
        "name": "Send Flowers",
        "youtube": "https://www.youtube.com/results?search_query=Send%20Flowers%20Crystal%20Lake"
    },
    {
        "name": "Katedral bat",
        "youtube": "https://www.youtube.com/results?search_query=Katedral%20bat%20Crystal%20Lake"
    },
    {
        "name": "Toki bat",
        "youtube": "https://www.youtube.com/results?search_query=Toki%20bat%20Crystal%20Lake"
    },
    {
        "name": "Etxe bat",
        "youtube": "https://www.youtube.com/results?search_query=Etxe%20bat%20Crystal%20Lake"
    },
    {
        "name": "Hegal egiten",
        "youtube": "https://www.youtube.com/results?search_query=Hegal%20egiten%20Crystal%20Lake"
    },
    {
        "name": "Lemak, Aingurak",
        "youtube": "https://www.youtube.com/results?search_query=Lemak%2C%20Aingurak%20Crystal%20Lake"
    },
    {
        "name": "Besterik Ez",
        "youtube": "https://www.youtube.com/results?search_query=Besterik%20Ez%20Crystal%20Lake"
    }
]

const Teksuo = [
    {
        name: "Endless",
        youtube: "https://www.youtube.com/results?search_query=Endless"
    },
    {
        name: "Raise The Flag",
        youtube: "https://www.youtube.com/results?search_query=Raise%20The%20Flag"
    },
    {
        name: "Lost In A Dream",
        youtube: "https://www.youtube.com/results?search_query=Lost%20In%20A%20Dream"
    },
    {
        name: "Rip My Heart Out",
        youtube: "https://www.youtube.com/results?search_query=Rip%20My%20Heart%20Out"
    },
    {
        name: "Nure Onna",
        youtube: "https://www.youtube.com/results?search_query=Nure%20Onna"
    },
    {
        name: "Natural Born Liars",
        youtube: "https://www.youtube.com/results?search_query=Natural%20Born%20Liars"
    },
    {
        name: "Holes (Live Version)",
        youtube: "https://www.youtube.com/results?search_query=Holes%20(Live%20Version)"
    },

]
// https://open.spotify.com/playlist/0hhqiOWK4G1ZNdqaAa48c0

const Electric_Alley = [
    {
        "name": "No Control",
        "youtube": "https://www.youtube.com/results?search_query=No%20Control%20Crystal%20Lake"
    },
    {
        "name": "Hurricane",
        "youtube": "https://www.youtube.com/results?search_query=Hurricane%20Crystal%20Lake"
    },
    {
        "name": "One Lasting Light",
        "youtube": "https://www.youtube.com/results?search_query=One%20Lasting%20Light%20Crystal%20Lake"
    },
    {
        "name": "Last Letter",
        "youtube": "https://www.youtube.com/results?search_query=Last%20Letter%20Crystal%20Lake"
    },
    {
        "name": "Make It Through the Night",
        "youtube": "https://www.youtube.com/results?search_query=Make%20It%20Through%20the%20Night%20Crystal%20Lake"
    },
    {
        "name": "Thunderbird or Vulture",
        "youtube": "https://www.youtube.com/results?search_query=Thunderbird%20or%20Vulture%20Crystal%20Lake"
    },
    {
        "name": "Cowboy Song",
        "youtube": "https://www.youtube.com/results?search_query=Cowboy%20Song%20Crystal%20Lake"
    },
    {
        "name": "Get Electrified!",
        "youtube": "https://www.youtube.com/results?search_query=Get%20Electrified!%20Crystal%20Lake"
    }
]

const The_OffSpring = [
    {
        "name": "Come Out and Play",
        "youtube": "https://www.youtube.com/results?search_query=Come%20Out%20and%20Play%20Crystal%20Lake"
    },
    {
        "name": "All I Want",
        "youtube": "https://www.youtube.com/results?search_query=All%20I%20Want%20Crystal%20Lake"
    },
    {
        "name": "Want You Bad",
        "youtube": "https://www.youtube.com/results?search_query=Want%20You%20Bad%20Crystal%20Lake"
    },
    {
        "name": "Staring at the Sun",
        "youtube": "https://www.youtube.com/results?search_query=Staring%20at%20the%20Sun%20Crystal%20Lake"
    },
    {
        "name": "Make It All Right",
        "youtube": "https://www.youtube.com/results?search_query=Make%20It%20All%20Right%20Crystal%20Lake"
    },
    {
        "name": "In the Hall of the Mountain King",
        "youtube": "https://www.youtube.com/results?search_query=In%20the%20Hall%20of%20the%20Mountain%20King%20Crystal%20Lake"
    },
    {
        "name": "Blitzkrieg Bop",
        "youtube": "https://www.youtube.com/results?search_query=Blitzkrieg%20Bop%20Crystal%20Lake"
    },
    {
        "name": "Hit That",
        "youtube": "https://www.youtube.com/results?search_query=Hit%20That%20Crystal%20Lake"
    },
    {
        "name": "Hammerhead",
        "youtube": "https://www.youtube.com/results?search_query=Hammerhead%20Crystal%20Lake"
    },
    {
        "name": "Original Prankster",
        "youtube": "https://www.youtube.com/results?search_query=Original%20Prankster%20Crystal%20Lake"
    },
    {
        "name": "Million Miles Away",
        "youtube": "https://www.youtube.com/results?search_query=Million%20Miles%20Away%20Crystal%20Lake"
    },
    {
        "name": "Bad Habit",
        "youtube": "https://www.youtube.com/results?search_query=Bad%20Habit%20Crystal%20Lake"
    },
    {
        "name": "Gotta Get Away",
        "youtube": "https://www.youtube.com/results?search_query=Gotta%20Get%20Away%20Crystal%20Lake"
    },
    {
        "name": "Why Don't You Get a Job?",
        "youtube": "https://www.youtube.com/results?search_query=Why%20Don't%20You%20Get%20a%20Job%3F%20Crystal%20Lake"
    },
    {
        "name": "(Can't Get My) Head Around You",
        "youtube": "https://www.youtube.com/results?search_query=(Can't%20Get%20My)%20Head%20Around%20You%20Crystal%20Lake"
    },
    {
        "name": "Pretty Fly (for a White Guy)",
        "youtube": "https://www.youtube.com/results?search_query=Pretty%20Fly%20(for%20a%20White%20Guy)%20Crystal%20Lake"
    },
    {
        "name": "The Kids Aren't Alright",
        "youtube": "https://www.youtube.com/results?search_query=The%20Kids%20Aren't%20Alright%20Crystal%20Lake"
    },
    {
        "name": "You're Gonna Go Far, Kid",
        "youtube": "https://www.youtube.com/results?search_query=You're%20Gonna%20Go%20Far%2C%20Kid%20Crystal%20Lake"
    },
    {
        "name": "Self Esteem",
        "youtube": "https://www.youtube.com/results?search_query=Self%20Esteem%20Crystal%20Lake"
    }
]


const Accept = [
    {
        "name": "The Reckoning",
        "youtube": "https://www.youtube.com/results?search_query=The%20Reckoning%20Crystal%20Lake"
    },
    {
        "name": "Humanoid",
        "youtube": "https://www.youtube.com/results?search_query=Humanoid%20Crystal%20Lake"
    },
    {
        "name": "Restless and Wild",
        "youtube": "https://www.youtube.com/results?search_query=Restless%20and%20Wild%20Crystal%20Lake"
    },
    {
        "name": "Overnight Sensation",
        "youtube": "https://www.youtube.com/results?search_query=Overnight%20Sensation%20Crystal%20Lake"
    },
    {
        "name": "Straight Up Jack",
        "youtube": "https://www.youtube.com/results?search_query=Straight%20Up%20Jack%20Crystal%20Lake"
    },
    {
        "name": "Midnight Mover",
        "youtube": "https://www.youtube.com/results?search_query=Midnight%20Mover%20Crystal%20Lake"
    },
    {
        "name": "Dying Breed",
        "youtube": "https://www.youtube.com/results?search_query=Dying%20Breed%20Crystal%20Lake"
    },
    {
        "name": "Princess of the Dawn",
        "youtube": "https://www.youtube.com/results?search_query=Princess%20of%20the%20Dawn%20Crystal%20Lake"
    },
    {
        "name": "Fast as a Shark",
        "youtube": "https://www.youtube.com/results?search_query=Fast%20as%20a%20Shark%20Crystal%20Lake"
    },
    {
        "name": "Metal Heart",
        "youtube": "https://www.youtube.com/results?search_query=Metal%20Heart%20Crystal%20Lake"
    },
    {
        "name": "Teutonic Terror",
        "youtube": "https://www.youtube.com/results?search_query=Teutonic%20Terror%20Crystal%20Lake"
    },
    {
        "name": "Pandemic",
        "youtube": "https://www.youtube.com/results?search_query=Pandemic%20Crystal%20Lake"
    },
    {
        "name": "Balls to the Wall",
        "youtube": "https://www.youtube.com/results?search_query=Balls%20to%20the%20Wall%20Crystal%20Lake"
    }
]

const Baby_Metal = [
    {
        "name": "BABYMETAL DEATH",
        "youtube": "https://www.youtube.com/results?search_query=BABYMETAL%20DEATH%20Crystal%20Lake"
    },
    {
        "name": "Distortion",
        "youtube": "https://www.youtube.com/results?search_query=Distortion%20Crystal%20Lake"
    },
    {
        "name": "PA PA YA!!",
        "youtube": "https://www.youtube.com/results?search_query=PA%20PA%20YA!!%20Crystal%20Lake"
    },
    {
        "name": "Megitsune",
        "youtube": "https://www.youtube.com/results?search_query=Megitsune%20Crystal%20Lake"
    },
    {
        "name": "BxMxC",
        "youtube": "https://www.youtube.com/results?search_query=BxMxC%20Crystal%20Lake"
    },
    {
        "name": "RATATATA",
        "youtube": "https://www.youtube.com/results?search_query=RATATATA%20Crystal%20Lake"
    },
    {
        "name": "KARATE",
        "youtube": "https://www.youtube.com/results?search_query=KARATE%20Crystal%20Lake"
    },
    {
        "name": "METALI!!",
        "youtube": "https://www.youtube.com/results?search_query=METALI!!%20Crystal%20Lake"
    },
    {
        "name": "Gimme Chocolate!!",
        "youtube": "https://www.youtube.com/results?search_query=Gimme%20Chocolate!!%20Crystal%20Lake"
    },
    {
        "name": "Road of Resistance",
        "youtube": "https://www.youtube.com/results?search_query=Road%20of%20Resistance%20Crystal%20Lake"
    }
]


const Electric_Callboy = [
    {
        "name": "Tekkno Train",
        "youtube": "https://www.youtube.com/results?search_query=Tekkno%20Train%20Crystal%20Lake"
    },
    {
        "name": "MC Thunder II (Dancing Like a Ninja)",
        "youtube": "https://www.youtube.com/results?search_query=MC%20Thunder%20II%20(Dancing%20Like%20a%20Ninja)%20Crystal%20Lake"
    },
    {
        "name": "Spaceman",
        "youtube": "https://www.youtube.com/results?search_query=Spaceman%20Crystal%20Lake"
    },
    {
        "name": "Hate/Love",
        "youtube": "https://www.youtube.com/results?search_query=Hate%2FLove%20Crystal%20Lake"
    },
    {
        "name": "Everytime We Touch",
        "youtube": "https://www.youtube.com/results?search_query=Everytime%20We%20Touch%20Crystal%20Lake"
    },
    {
        "name": "Castrop X Spandau",
        "youtube": "https://www.youtube.com/results?search_query=Castrop%20X%20Spandau%20Crystal%20Lake"
    },
    {
        "name": "Arrow of Love",
        "youtube": "https://www.youtube.com/results?search_query=Arrow%20of%20Love%20Crystal%20Lake"
    },
    {
        "name": "Hypa Hypa",
        "youtube": "https://www.youtube.com/results?search_query=Hypa%20Hypa%20Crystal%20Lake"
    },
    {
        "name": "Parasite",
        "youtube": "https://www.youtube.com/results?search_query=Parasite%20Crystal%20Lake"
    },
    {
        "name": "RATATATA",
        "youtube": "https://www.youtube.com/results?search_query=RATATATA%20Crystal%20Lake"
    },
    {
        "name": "Hurrikan",
        "youtube": "https://www.youtube.com/results?search_query=Hurrikan%20Crystal%20Lake"
    },
    {
        "name": "MC Thunder",
        "youtube": "https://www.youtube.com/results?search_query=MC%20Thunder%20Crystal%20Lake"
    },
    {
        "name": "Pump It",
        "youtube": "https://www.youtube.com/results?search_query=Pump%20It%20Crystal%20Lake"
    },
    {
        "name": "Mindreader",
        "youtube": "https://www.youtube.com/results?search_query=Mindreader%20Crystal%20Lake"
    },
    {
        "name": "We Got the Moves",
        "youtube": "https://www.youtube.com/results?search_query=We%20Got%20the%20Moves%20Crystal%20Lake"
    }
]

const Megadeth = [
    {
        "name": "The Sick, the Dying… and the Dead!",
        "youtube": "https://www.youtube.com/results?search_query=The%20Sick%2C%20the%20Dying%E2%80%A6%20and%20the%20Dead!%20Crystal%20Lake"
    },
    {
        "name": "Take No Prisoners",
        "youtube": "https://www.youtube.com/results?search_query=Take%20No%20Prisoners%20Crystal%20Lake"
    },
    {
        "name": "Dread and the Fugitive Mind",
        "youtube": "https://www.youtube.com/results?search_query=Dread%20and%20the%20Fugitive%20Mind%20Crystal%20Lake"
    },
    {
        "name": "Angry Again",
        "youtube": "https://www.youtube.com/results?search_query=Angry%20Again%20Crystal%20Lake"
    },
    {
        "name": "Kick the Chair",
        "youtube": "https://www.youtube.com/results?search_query=Kick%20the%20Chair%20Crystal%20Lake"
    },
    {
        "name": "Skin o' My Teeth",
        "youtube": "https://www.youtube.com/results?search_query=Skin%20o'%20My%20Teeth%20Crystal%20Lake"
    },
    {
        "name": "Hangar 18",
        "youtube": "https://www.youtube.com/results?search_query=Hangar%2018%20Crystal%20Lake"
    },
    {
        "name": "Sweating Bullets",
        "youtube": "https://www.youtube.com/results?search_query=Sweating%20Bullets%20Crystal%20Lake"
    },
    {
        "name": "Tornado of Souls",
        "youtube": "https://www.youtube.com/results?search_query=Tornado%20of%20Souls%20Crystal%20Lake"
    },
    {
        "name": "Trust",
        "youtube": "https://www.youtube.com/results?search_query=Trust%20Crystal%20Lake"
    },
    {
        "name": "We'll Be Back",
        "youtube": "https://www.youtube.com/results?search_query=We'll%20Be%20Back%20Crystal%20Lake"
    },
    {
        "name": "Symphony of Destruction",
        "youtube": "https://www.youtube.com/results?search_query=Symphony%20of%20Destruction%20Crystal%20Lake"
    },
    {
        "name": "Peace Sells",
        "youtube": "https://www.youtube.com/results?search_query=Peace%20Sells%20Crystal%20Lake"
    },
    {
        "name": "Holy Wars... The Punishment Due",
        "youtube": "https://www.youtube.com/results?search_query=Holy%20Wars...%20The%20Punishment%20Due%20Crystal%20Lake"
    }
]

const Avenged_Sevenfold = [
    {
        "name": "Game Over",
        "youtube": "https://www.youtube.com/results?search_query=Game%20Over%20Crystal%20Lake"
    },
    {
        "name": "Mattel",
        "youtube": "https://www.youtube.com/results?search_query=Mattel%20Crystal%20Lake"
    },
    {
        "name": "Afterlife",
        "youtube": "https://www.youtube.com/results?search_query=Afterlife%20Crystal%20Lake"
    },
    {
        "name": "Hail to the King",
        "youtube": "https://www.youtube.com/results?search_query=Hail%20to%20the%20King%20Crystal%20Lake"
    },
    {
        "name": "Buried Alive",
        "youtube": "https://www.youtube.com/results?search_query=Buried%20Alive%20Crystal%20Lake"
    },
    {
        "name": "So Far Away",
        "youtube": "https://www.youtube.com/results?search_query=So%20Far%20Away%20Crystal%20Lake"
    },
    {
        "name": "Unholy Confessions",
        "youtube": "https://www.youtube.com/results?search_query=Unholy%20Confessions%20Crystal%20Lake"
    },
    {
        "name": "Nobody",
        "youtube": "https://www.youtube.com/results?search_query=Nobody%20Crystal%20Lake"
    },
    {
        "name": "Nightmare",
        "youtube": "https://www.youtube.com/results?search_query=Nightmare%20Crystal%20Lake"
    },
    {
        "name": "A Little Piece of Heaven",
        "youtube": "https://www.youtube.com/results?search_query=A%20Little%20Piece%20of%20Heaven%20Crystal%20Lake"
    },
    {
        "name": "Save Me",
        "youtube": "https://www.youtube.com/results?search_query=Save%20Me%20Crystal%20Lake"
    },
    {
        "name": "Cosmic",
        "youtube": "https://www.youtube.com/results?search_query=Cosmic%20Crystal%20Lake"
    }
]

const Corey_Taylor = [
    {
        "name": "Post Traumatic Blues",
        "youtube": "https://www.youtube.com/results?search_query=Post%20Traumatic%20Blues"
    },
    {
        "name": "Made of Scars",
        "youtube": "https://www.youtube.com/results?search_query=Made%20of%20Scars"
    },
    {
        "name": "Black Eyes Blue",
        "youtube": "https://www.youtube.com/results?search_query=Black%20Eyes%20Blue"
    },
    {
        "name": "We Are the Rest",
        "youtube": "https://www.youtube.com/results?search_query=We%20Are%20the%20Rest"
    },
    {
        "name": "Song #3",
        "youtube": "https://www.youtube.com/results?search_query=Song%20%233"
    },
    {
        "name": "Beyond",
        "youtube": "https://www.youtube.com/results?search_query=Beyond"
    },
    {
        "name": "Before I Forget",
        "youtube": "https://www.youtube.com/results?search_query=Before%20I%20Forget"
    },
    {
        "name": "SpongeBob SquarePants Theme",
        "youtube": "https://www.youtube.com/results?search_query=SpongeBob%20SquarePants%20Theme"
    },
    {
        "name": "Snuff",
        "youtube": "https://www.youtube.com/results?search_query=Snuff"
    },
    {
        "name": "From Can to Can't",
        "youtube": "https://www.youtube.com/results?search_query=From%20Can%20to%20Can't"
    },
    {
        "name": "Home",
        "youtube": "https://www.youtube.com/results?search_query=Home"
    },
    {
        "name": "Through Glass",
        "youtube": "https://www.youtube.com/results?search_query=Through%20Glass"
    },
    {
        "name": "Duality",
        "youtube": "https://www.youtube.com/results?search_query=Duality"
    }
]
const all = {
    Alice_Cooper,
    Crystal_Lake,
    Machine_Head,
    Sum_41,
    Bruce_Dickinson,
    Bring_Me_The_Horizon,
    Gorka,
    Teksuo,
    Electric_Alley,
    The_OffSpring,
    Accept,
    Baby_Metal,
    Electric_Callboy,
    Megadeth,
    Avenged_Sevenfold,
    Corey_Taylor
}
export default all;


/*

// Ensure Chart.js is loaded
if (typeof Chart === 'undefined') {
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
  document.head.appendChild(script);
  script.onload = createGraph;
} else {
  createGraph();
}

function createGraph() {
  // Reference to pollresult (you can paste the pollresult object here directly)
  const pollresult = await fetch('https://netofcomputers.com:3090/tbotw/pollresults').then(res => res.json());

  // Create a dictionary to store song frequencies
  const songCount = {};

  // Loop through pollresult to count song selections
  pollresult.forEach((person) => {
    person.selected.forEach((song) => {
      songCount[song] = (songCount[song] || 0) + 1;
    });
  });

  // Prepare data for the chart
  const songNames = Object.keys(songCount);
  const songFrequencies = Object.values(songCount);

  // Create a canvas element to insert the graph
  const canvas = document.createElement('canvas');
  document.body.appendChild(canvas);

  // Create the chart
  new Chart(canvas, {
    type: 'bar',
    data: {
      labels: songNames,
      datasets: [{
        label: 'Song Frequency',
        data: songFrequencies,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        x: {
          beginAtZero: true,
          ticks: {
            maxRotation: 45,
            minRotation: 0
          }
        },
        y: {
          beginAtZero: true
        }
      },
      responsive: true,
      plugins: {
        tooltip: {
          callbacks: {
            label: function(context) {
              return context.raw + ' votes';
            }
          }
        }
      }
    }
  });
}

ƒ createGraph() {
  // Reference to pollresult (you can paste the pollresult object here directly)
  const pollresult = [
    {
      "name": "Jaime",
      "selected": [
        "Song #3", "We Are the…

*/